import { Loader2 } from 'lucide-react';

import { cn } from '@/_shared/lib/utils';

import type { StepStatus } from '../types';

interface StepResultProps {
  status: StepStatus;
  /** The fresh/stale result body (already populated from the latest run). */
  children: React.ReactNode;
}

/**
 * The dry-run result body for a step's "Preview" footer. Renders one of three states: loading
 * (spinner), fresh (the result), or stale (the result dimmed). The "Stale" badge, idle state, and the
 * surrounding divider/heading are owned by the footer (see {@link StepCard}), which renders only when
 * `hasStepPreview` says so.
 */
export function StepResult({ status, children }: StepResultProps): React.ReactElement | null {
  if (status === 'idle') return null;

  if (status === 'loading') {
    return (
      <div role="status" className="flex items-center gap-2 text-xs font-medium text-muted-foreground">
        <Loader2 aria-hidden className="size-3.5 animate-spin" />
        Running…
      </div>
    );
  }

  return <div className={cn('transition-opacity', status === 'stale' && 'opacity-50')}>{children}</div>;
}
